import { Box, Heading } from "@chakra-ui/react";

interface LegalSectionProps {
  title: string;
  children: React.ReactNode;
}

export default function LegalSection({ title, children }: LegalSectionProps) {
  return (
    <Box mb={8}>
      <Heading
        fontFamily="heading"
        fontWeight="800"
        fontSize={{ base: "16px", md: "18px" }}
        color="text.primary"
        mb={3}
      >
        {title}
      </Heading>
      {children}
    </Box>
  );
}
